import { render, staticRenderFns } from "./main.vue?vue&type=template&id=bb22ff0e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=bb22ff0e&prod&lang=less&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=bb22ff0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb22ff0e",
  null
  
)

export default component.exports